import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useCalendarHeightContainer } from '../hooks/useCalendarHeightContainer';
import { ComponentsDispatch, RootState } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';

interface ICalendarContainer {
    children: React.JSX.Element | React.JSX.Element[];
}

const CalendarContainer: React.FC<ICalendarContainer> = ({ children }) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const paddingBottom = useSelector<RootState, number>((state) => state.calendar.paddingBottom);
    const containerParent = useRef<HTMLDivElement>(null);
    const heightContainer = useCalendarHeightContainer(containerParent) - paddingBottom;

    useEffect(() => {
        dispatch(setterCalendar({ availableHeight: heightContainer }));
    }, [heightContainer]);

    return (
        <div
            ref={containerParent}
            style={{
                height: heightContainer,
                overflow: 'auto',
                position: 'relative',
            }}
        >
            {children}
        </div>
    );
};

export default React.memo(CalendarContainer);
